export const fetchSendSonarToken = () => ({
  type: 'FETCH_SEND_SONAR_TOKEN',
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'get',
      url: `/v1/api/ura/sonar/phone/token`
    }
  }
})

export const fetchValidateSonarToken = (data) => ({
  type: 'FETCH_VALIDATE_SONAR_TOKEN',
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'post',
      url: `/v1/api/ura/sonar/phone/validate`,
      data: data
    }
  }
})

export const fetchSendCognitoToken = () => ({
  type: 'FETCH_SEND_COGNITO_TOKEN',
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'get',
      url: `/v1/api/ura/unlock/password/token`
    }
  }
})

export const fetchUnlockUra = (data) => ({
  type: 'FETCH_UNLOCK_URA',
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'post',
      url: `/v1/api/ura/unlock/password/change`,
      data: data
    }
  }
})

export const fetchSonarStatus = () => ({
  type: 'FETCH_GET_SONAR_STATUS',
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'get',
      url: `/v1/api/ura/status`
    }
  }
})

export const fetchCheckPassword = data => ({
  type: 'FETCH_CHECK_PASSWORD',
  payload: {
    client: 'onboardingApi',
    request: {
      method: 'post',
      url: `v1/api/ura/legacy/passwordNumber/validate`,
      data
    }
  }
})

export default {
  fetchSendSonarToken,
  fetchValidateSonarToken,
  fetchSendCognitoToken,
  fetchUnlockUra,
  fetchSonarStatus,
  fetchCheckPassword
}



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/UnlockUraPassword/actions.js